import { Box, Button } from "@modernatx-internal/component-library";
import React from "react";

import type { FinderFooterBlockProps } from "./DesktopFooter";
import { FinderFooterContent } from "./FinderFooterContent";

export const MobileFooter: React.FC<FinderFooterBlockProps> = ({
  locale = "en-US",
  mainContent,
  subSection
}) => {
  const [open, setOpen] = React.useState(false);

  const handleHamburgerClick = () => setOpen((prev) => !prev);

  return (
    <>
      {/* Hamburger icon in top right */}
      <Button
        aria-label="Open footer menu"
        icon="list"
        iconPosition="end"
        size="lg"
        sx={{
          display: ["initial", null, "none"],
          position: "fixed",
          right: "spacing-3",
          top: "spacing-3",
          zIndex: "panel"
        }}
        variant={open ? "filled" : "subtle"}
        onClick={handleHamburgerClick}
      />
      {/* Footer dropdown overlay - always present but controlled by opacity/visibility */}
      <Box
        sx={{
          backgroundColor: "white",
          display: ["flex", null, "none"],
          flexDirection: "column",
          height: () => "calc(100% - 61px)", // Adjust height to account for fixed header
          left: 0,
          overflowY: "auto",
          position: "fixed",
          top: () => "61px",
          width: "100vw",
          zIndex: "panel",
          opacity: open ? 1 : 0,
          visibility: open ? "visible" : "hidden",
          transition: () => "opacity 200ms ease-in-out, visibility 200ms ease-in-out",
          pointerEvents: open ? "auto" : "none"
        }}
      >
        <Box sx={{ px: 4, width: "100%", maxWidth: 600, mx: "auto" }}>
          <FinderFooterContent
            expanded={true}
            locale={locale}
            mainContent={mainContent}
            subSection={subSection}
          />
        </Box>
      </Box>
    </>
  );
};
